import {ROLE_MANAGER} from '../../vuex/modules/auth/models/current-user';

const manager = async ({next, store}) => store.getters['auth/currentUser'].role === ROLE_MANAGER ? next() : next({name: 'index'});

export default manager;